<template>
    <div class="box">
        <div class="order-module">
            <div v-if="productDetail.type != 2">
                <!-- 有地址 -->
                <div class="address font24" v-if="selectedAddress" @click="changeAddress">
                    <div class="icon">
                        <van-icon name="location" size="20px" />
                    </div>
                    <div class="addr-box">
                        <div class="addr-top flex flex-between flex-y-center">
                            <span class="addr-name" decode="true">{{ selectedAddress.name }} {{ selectedAddress.phone
                                }}</span>
                            <img class="arrow" src="https://static.beautyfarm.com.cn/beauty_image/20211127/right-arrow.png" alt="" />
                        </div>
                        <div class="addr-bottom">
                            {{ addressInfo }}
                        </div>
                    </div>
                </div>
                <!-- 无地址 -->
                <div class="noaddress font24" v-else>
                    <div class="noaddr" @click="changeAddress">
                        <div>
                            <van-icon name="location" size="20px" />
                            添加收货地址
                        </div>
                        <div class="arrow">
                            <van-icon name="arrow" size="16px" color="#C8D0D5" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="info-box">
                <img class="image" :src="productDetail.listImg" mode="aspectFit|aspectFill|widthFix" alt="" />
                <div class="info">
                    <div class="info-title font30">{{ productDetail.title }}</div>
                    <div class="info-number">
                        <div class="font34 red">{{ productDetail.price }}</div>
                        <div>
                            <van-stepper :integer="true" v-model="buyNum" class="num" :min="1" input-width="45" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="method-box font28" v-if="productDetail.type != 2">
                <div class="method-tit">配送方式</div>
                <div class="method">快递免邮(普通配送)</div>
            </div>
        </div>
        <div class="orderbottom flex-row flex-y-center flex-between" :style="`padding-bottom:0px`">
            <div class="flex-row flex-y-center" style="line-height:120px">
                <span class="black font28">合计积分：</span>
                <span class="font40 red">{{ totalPrice }}</span>
            </div>
            <button class="buy font28 White" @click="openDialog" :disabled="btnClicked">确认兑换</button>
        </div>
        <van-dialog id="van-dialog" confirm-button-color="#4775D4" />
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Toast, Dialog } from 'vant'
    import { mapState } from 'vuex';

    export default {
        name: 'exchangeOrderJoin',
        components: {},
        computed: {
            ...mapState({
                addressDetail: (state) => state.order.addressDetail
            }),
            addressInfo() {
                const { province, city, district, street } = this.selectedAddress
                return province + (province == city ? '' : city) + district + street
            },
            selectedAddress() {
                // 存在被选中的地址详情就用被选中的，否则就用默认地址，两个都没有就是 null
                return this.addressDetail || this.defaultAddress
            },
            totalPrice() {
                return this.productDetail.price * this.buyNum
            }
        },
        data() {
            return {
                defaultAddress: null,
                buyNum: 1, //个数
                btnClicked: false, // 暴力点击
                // addressid: "", // 地址id
                productDetail: {}
            }
        },
        mounted() {
            this.productDetail = JSON.parse(this.$route.query.productDetail)
            console.log(this.productDetail.type);
            this.recAddressList()
        },
        methods: {
            // 获取收货地址列表
            recAddressList() {
                request({
                    url: "/jm/address/recAddressList",
                    method: "get",
                })
                    .then((res) => {
                        const recAddressList = Array.isArray(res.data) ? res.data : []
                        const defaultAddressData = recAddressList.find((item) => item.isDefault == 1)
                        this.defaultAddress = defaultAddressData?.addressDTO
                        if (this.addressDetail && !recAddressList.find(item => item.id === this.addressDetail.id)) {
                            this.$store.commit('order/SET_ADDRESS_DETAIL', null)
                        }

                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            // 更改地址
            changeAddress() {
                this.$router.push({ name: "myAddressJm", query: { type: 'order' } });
            },
            // 告知弹框
            openDialog() {
                Dialog.confirm({
                    title: '兑换告知',
                    message: '每月兑换时间截止至当月15日，发货时间为当月下旬，代金券实时到账，超过当月兑换时间的订单将在下个月进行。',
                })
                    .then(() => {
                        this.submitOrder()
                    })
                    .catch(() => {
                    });
            },
            // 提交订单
            submitOrder() {
                if (this.productDetail.type != 2) {
                    if (this.selectedAddress) {
                        this.toBuy();
                    } else {
                        Toast({ position: 'top', message: '请选择收货地址' })
                    }
                } else {
                    this.toBuy();
                }

            },
            // 下单
            toBuy() {
                let obj2 = {
                    goodsKey: this.productDetail.id,
                    address: JSON.stringify(this.selectedAddress),
                    userMsg: "",
                    extend: "积分兑换",
                    goodsPrice: this.totalPrice,
                    number: this.buyNum,
                    orderFrom: "pos",
                };
                request({
                    url: `/jm/order/buy`,
                    method: "post",
                    data: obj2
                })
                    .then((res) => {
                        Toast({ position: 'top', message: '兑换成功' })
                        this.$router.push({
                            name: "biRecordJoin"
                        });
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },


        },
    }
</script>

<style scoped lang="less">
    .box {
        background-color: #f7f4f8;
    }

    .order-module {
        height: 100vh;
        padding: 22px 30px;
    }

    .address {
        width: 100%;
        /* height: 184px; */
        background: #ffffff;
        border-radius: 8px;
        margin: 0 auto;
        padding: 20px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-around;
    }

    .address .icon {
        width: 60px;
    }

    .address .addr-box {
        flex: 1;
    }

    .noaddress {
        width: 100%;
        min-height: 105px;
        height: auto;
        background: #ffffff;
        border-radius: 8px;
        margin: 0 auto;
        color: #666;
    }

    .addr-tit {
        text-align: left;
        margin-left: 30px;
        margin-top: 30px;
        margin-bottom: 30px;
    }

    .noaddr {
        height: 145px;
        line-height: 145px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 32px;
        color: #35434c;
        padding: 0 30px;
    }

    .address .arrow {
        width: 16px;
        height: 24px;
    }

    .addr-top {
        margin-bottom: 12px;
    }

    .addr-icon {
        width: 37px;
        height: 45px;
    }

    .address .arrow {
        width: 16px;
        height: 24px;
    }

    .addr-bottom {
        height: 65px;
        display: -webkit-box;
        word-break: break-all;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #666;
    }

    .addr-name {
        flex: 1;
    }

    .info-box {
        width: 689px;
        height: 276px;
        background: #ffffff;
        border-radius: 20px;
        padding: 23px 20px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }

    .info-box .image {
        width: 230px;
        height: 230px;
        border-radius: 8px;
        margin-right: 32px;
    }

    .info-box .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .info-box .info-title {
        height: 180px;
        color: #35434c;
    }

    .info-box .info-number {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .info-box>view {
        flex: 1;
    }

    .red {
        color: #ee4c4c;
    }

    .black {
        color: #35434c;
    }

    .method-box {
        margin-top: 20px;
        width: 690px;
        height: 100px;
        background: #ffffff;
        border-radius: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 30px 20px;
        box-sizing: border-box;
        color: #35434c;
    }

    .method-tit {
        min-width: 112px;
    }

    .method {
        flex: 1;
        text-align: right;
    }

    .orderbottom {
        position: fixed;
        bottom: 0;
        width: 750px;
        padding: 0 30px;
        height: 120px;
        box-sizing: border-box;
        z-index: 10;
        background-color: #fff;
    }

    .buy {
        width: 220px !important;
        height: 70px !important;
        text-align: center;
        background: #333f48;
        border-radius: 40px;
        margin: 0 !important;
        font-weight: normal;
    }

    .van-dialog__button {
        flex: none !important;
        width: 50% !important;
    }

    :deep(.van-stepper) {
        border: 1px solid #cccccc;
        height: 48px;
    }

    :deep(.van-stepper__minus) {
        background-color: #fff;
        height: 44px;
    }

    :deep(.van-stepper__input) {
        background-color: #fff;
        height: 44px;
    }

    :deep(.van-stepper__plus) {
        background-color: #fff;
        height: 44px;
    }

    :deep(.van-stepper__plus::after) {
        height: 40%;
    }

    :deep(.van-stepper__plus::before) {
        width: 35%;
    }

    :deep(.van-stepper__minus::before) {
        width: 35%;
    }
</style>